import {
  AppWindow,
  Blocks,
  BookOpen,
  ClipboardCheck,
  Code,
  Compass,
  Cog,
  Database,
  FileText,
  Filter,
  Gauge,
  GitBranch,
  Languages,
  Layers,
  LayoutPanelTop,
  LayoutTemplate,
  LineChart,
  Link2,
  Magnet,
  Mail,
  MapPin,
  MessageCircle,
  MessageSquare,
  Monitor,
  MousePointerClick,
  Paintbrush,
  PenTool,
  Presentation,
  RefreshCw,
  RotateCcw,
  Scale,
  Share2,
  ShoppingCart,
  Sparkles,
  TrendingUp,
  Workflow,
  type LucideIcon,
} from "lucide-react";

/** Lucide export names for service directory sub-link cards (`nav-services-mega.json`). */
export type CcServiceDirectoryLinkIconName =
  | "AppWindow"
  | "Blocks"
  | "BookOpen"
  | "ClipboardCheck"
  | "Code"
  | "Compass"
  | "Cog"
  | "Database"
  | "FileText"
  | "Filter"
  | "Gauge"
  | "GitBranch"
  | "Languages"
  | "Layers"
  | "LayoutPanelTop"
  | "LayoutTemplate"
  | "LineChart"
  | "Link2"
  | "Magnet"
  | "Mail"
  | "MapPin"
  | "MessageCircle"
  | "MessageSquare"
  | "Monitor"
  | "MousePointerClick"
  | "Paintbrush"
  | "PenTool"
  | "Presentation"
  | "RefreshCw"
  | "RotateCcw"
  | "Scale"
  | "Share2"
  | "ShoppingCart"
  | "Sparkles"
  | "TrendingUp"
  | "Workflow";

const SERVICE_DIRECTORY_LINK_ICONS: Record<
  CcServiceDirectoryLinkIconName,
  LucideIcon
> = {
  AppWindow,
  Blocks,
  BookOpen,
  ClipboardCheck,
  Code,
  Compass,
  Cog,
  Database,
  FileText,
  Filter,
  Gauge,
  GitBranch,
  Languages,
  Layers,
  LayoutPanelTop,
  LayoutTemplate,
  LineChart,
  Link2,
  Magnet,
  Mail,
  MapPin,
  MessageCircle,
  MessageSquare,
  Monitor,
  MousePointerClick,
  Paintbrush,
  PenTool,
  Presentation,
  RefreshCw,
  RotateCcw,
  Scale,
  Share2,
  ShoppingCart,
  Sparkles,
  TrendingUp,
  Workflow,
};

export function isServiceDirectoryLinkIconName(
  value: string,
): value is CcServiceDirectoryLinkIconName {
  return Object.prototype.hasOwnProperty.call(SERVICE_DIRECTORY_LINK_ICONS, value);
}

export function getServiceDirectoryLinkIcon(
  iconName: CcServiceDirectoryLinkIconName,
): LucideIcon {
  return SERVICE_DIRECTORY_LINK_ICONS[iconName];
}
